import { useApi } from './apiService';

export const useCacheManagement = () => {
  const api = useApi();

  const getCachePrefixes = async (project: string): Promise<string[]> => {
    const response = await api.get(`${project}/CacheManagement/prefixes`);
    const data = response?.data;
    return Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
  };

  // Flush is identical across every project's backend — calling it for any single
  // project flushes the shared cache, so callers only need to invoke this once.
  const flushCache = async (project: string) => {
    const response = await api.post(`${project}/CacheManagement/flush`);
    return response?.data;
  };

  const clearCachePrefixes = async (project: string, prefixes: string[]) => {
    const response = await api.post(`${project}/CacheManagement/clear`, { prefixes });
    return response?.data;
  };

  return { getCachePrefixes, flushCache, clearCachePrefixes };
};
